import { render } from "./DateTimePicker.vue?vue&type=template&id=2229fc4c"
import script from "./DateTimePicker.vue?vue&type=script&lang=js"
export * from "./DateTimePicker.vue?vue&type=script&lang=js"

import "./DateTimePicker.vue?vue&type=style&index=0&id=2229fc4c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__